// frontend/src/utils/passwordPolicy.js
//
// Client-side mirror of staff_core.utils.password_utils.validate_password_strength.
// PASSWORD_SPECIAL_CHARACTERS must stay identical to the Python constant.
// NRIC and date of birth are checked on the server only — the browser never
// receives those values.

export const PASSWORD_MIN_LENGTH = 8;
export const DEFAULT_STAFF_PASSWORD = 'password123';
export const PASSWORD_SPECIAL_CHARACTERS = "!@#$%^&*()_+-=[]{}|;':\",./<>?";

const SPECIAL_PATTERN = /[!@#$%^&*()_+\-=[\]{}|;':",./<>?]/;

export const PASSWORD_REQUIREMENT_ITEMS = [
  { key: 'length', text: 'At least 8 characters' },
  { key: 'uppercase', text: 'One uppercase letter' },
  { key: 'lowercase', text: 'One lowercase letter' },
  { key: 'number', text: 'One number' },
  { key: 'special', text: 'One symbol (! @ # $)' },
];

export const PASSWORD_IDENTITY_HELPER = 'Do not include your NRIC/FIN or date of birth.';

export function getPasswordRequirementChecks(password) {
  const value = password || '';
  return {
    length: value.length >= PASSWORD_MIN_LENGTH,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /[0-9]/.test(value),
    special: SPECIAL_PATTERN.test(value),
  };
}

export function passwordMeetsComplexity(password) {
  const checks = getPasswordRequirementChecks(password);
  return PASSWORD_REQUIREMENT_ITEMS.every((item) => checks[item.key]);
}

export function passwordComplexityError(password) {
  const value = password || '';
  if (value.length < PASSWORD_MIN_LENGTH) {
    return 'Password must be at least 8 characters long.';
  }

  const checks = getPasswordRequirementChecks(value);
  const missing = [];
  if (!checks.uppercase) missing.push('an uppercase letter');
  if (!checks.lowercase) missing.push('a lowercase letter');
  if (!checks.number) missing.push('a number');
  if (!checks.special) missing.push('a symbol');

  if (missing.length === 0) return null;
  if (missing.length === 1) return `Password must include ${missing[0]}.`;
  const listed = `${missing.slice(0, -1).join(', ')}, and ${missing[missing.length - 1]}`;
  return `Password must include ${listed}.`;
}
